'use client';
import getLocal from 'eco-design-reliance/getLocal';
import gtm from 'eco-design-reliance/gtm';
import { useEffect, useRef } from 'react';
import ToTopIcon2 from '../../comps/ToTopIcon2';
// dpux 页面特殊处理
const pages = ['/delta-pro-ultra-x'];
export default function WidgetsItemBackToTop() {
    const { pathname } = getLocal();
    const refTop = useRef<any>(null);
    // 滚动到顶部
    const toTopFn = () => {
        if (typeof window === 'undefined') return;
        // 获取当前页面url
        if (pages.includes(pathname)) {
            try {
                const scrollTop = window.sessionStorage.getItem('toTop-scrollTop');
                if (!scrollTop) {
                    window.scrollTo(0, 0);
                } else {
                    const Numb = parseInt(scrollTop);
                    window.scrollTo(0, Numb);
                }
            } catch (e) {
                console.log('数据出错', e);
            }
        } else {
            window.scrollTo(0, 0);
        }
        gtm.push({
            event: 'uaEvent',
            event_name: 'floating_button',
            button_name: 'back_to_top',
            __btn_type: 'common',
            __btn_id1: 'WidgetsItem-BackToTop',
            __btn_id2: 'BackToTop',
        });
    };

    useEffect(() => {
        window.addEventListener('scroll', () => {
            const pageYOffset = window.pageYOffset;
            if (pageYOffset > 100) {
                refTop.current && refTop.current.classList && refTop.current.classList.add('show-top');
            } else {
                refTop.current && refTop.current.classList && refTop.current.classList.remove('show-top');
            }
        });
    }, []);
    return (
        <div className="WidgetsItem WidgetsItem-BackToTop GtmModuleData-btn-common" data-btn-id="BackToTop">
            <div className="WidgetsItem-icon" ref={refTop} onClick={toTopFn}>
                <ToTopIcon2 />
            </div>
        </div>
    );
}
